import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star, Mic, Users, Award, FileText } from 'lucide-react';
import { achievements } from '../mock';

const icons = [Trophy, Star, Users, Mic, Award, FileText];

const Achievements = () => {
  return (
    <section id="achievements" className="relative py-32 bg-background overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-20 pointer-events-none" />
      <div
        className="absolute -top-20 right-1/3 w-[500px] h-[500px] rounded-full opacity-[0.08] blur-[100px] pointer-events-none"
        style={{ background: 'radial-gradient(circle, #f4a261 0%, transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <span className="mono text-xs uppercase tracking-widest text-primary mb-4 block">// 06 — Achievements</span>
            <h2 className="serif text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.1]">
              Recognition<br />
              <span className="italic text-slate-500">that mattered</span>.
            </h2>
          </div>
          <div className="lg:col-span-7 flex items-end">
            <p className="text-slate-400 text-lg leading-relaxed">
              Milestones I'm genuinely proud of — the ones that came from solving real problems for real teams, not from chasing trophies.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {achievements.map((a, i) => {
            const Icon = icons[i % icons.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="group p-6 rounded-2xl bg-card border border-white/5 hover:border-primary/40 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10"
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-11 h-11 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                    <Icon size={20} />
                  </div>
                  <span className="mono text-xs uppercase tracking-widest text-slate-600">{a.year}</span>
                </div>
                <h3 className="text-white font-semibold text-base mb-2 group-hover:text-primary transition-colors">{a.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{a.detail}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
